<template>
  <div>
    <el-container>
      <el-aside>
        <el-row class="tac">
          <el-col>
            <!--<h5>自定义颜色</h5>-->
            <div class="userInfo" style="border-bottom: 1px solid #ccc;">
              <div class="img_box" @click="toSetting">
                <img class="img" :src="user.pic" alt="" v-if="user.pic && user.pic != '/images/mine_deep.png'">
                <img class="img" src="../../static/mine_deep.png" alt="" v-else>
              </div>
              <div class="info_box">
                <p class="info" v-if="user.isChannel == 2">{{user.hospital.hospitalName}}</p>
                <p class="info" v-else>{{user.name}}</p>
                <p class="label" v-if="user.isChannel == 2">{{user.hospital.type}}</p>
                <p class="label" v-if="user.isChannel == 1 && user.channel.parentId == 0">代理商</p>
                <p class="label" v-if="user.isChannel == 1 && user.channel.parentId != 0">经销商</p>
                <p class="label" v-if="user.isChannel == 3">业务员</p>
              </div>
            </div>
            <p class="imghide navleft_menu" @click="toshow"><img src="../assets/ml.png" width="16" height="13"  alt="">&nbsp;菜单</p>
            <el-menu :default-active="activeIndex" class="el-menu-vertical-demo imghide " :class="[show?'on':'imghide']"  @open="handleOpen" @close="handleClose" style="margin-top:10px;border:none">
              <el-menu-item index="1" @click="toOrderList">
                <i class="el-icon-menu"></i>
                <span slot="title">我的订单</span>
              </el-menu-item>
               <el-menu-item index="7" @click="toUserList" v-if="user.isChannel == 1">
                <i class="el-icon-menu"></i>
                <span slot="title">用户订单</span>
              </el-menu-item>
              <el-menu-item index="8" @click="toCustomerList" v-if="user.isChannel == 3">
                <i class="el-icon-menu"></i>
                <span slot="title">客户订单</span>
              </el-menu-item>
              <el-menu-item index="2" @click="toMyAddress">
                <i class="el-icon-document"></i>
                <span slot="title">我的地址</span>
              </el-menu-item>
              <el-menu-item index="3" @click="toMyReport">
                <i class="el-icon-tickets"></i>
                <span slot="title">我的报告</span>
              </el-menu-item>
              <!--<el-menu-item index="4" @click="toMyRefund">-->
              <!--<i class="el-icon-menu"></i>-->
              <!--<span slot="title">我的退换</span>-->
              <!--</el-menu-item>-->
              <el-menu-item index="9" @click="toMyCoupons">
                <img class="navleft-icon" v-if="activeIndex === '9'" src="../assets/icon-mycoupons.png"/>
                <img class="navleft-icon" v-else src="../assets/icon-mycoupons-gray.png"/>
                <span slot="title">我的优惠券</span>
              </el-menu-item>
              <el-menu-item index="5" @click="toSetting">
                <i class="el-icon-setting"></i>
                <span slot="title">账户设置</span>
              </el-menu-item>
               <el-menu-item index="10" @click="toCouponsCenter">
                <img class="navleft-icon" v-if="activeIndex === '10'" src="../assets/icon-coupons-center.png"/>
                <img class="navleft-icon" v-else src="../assets/icon-coupons-center-gray.png"/>
                <span slot="title">领券中心</span>
              </el-menu-item>
              <el-menu-item index="6" @click="toSample" v-if="user.isChannel != 0">
                <i class="el-icon-setting"></i>
                <span slot="title">标本管理</span>
              </el-menu-item>
              <el-menu-item index="" @click="toManageSystem" v-if="user.isChannel != 0">
                <i class="el-icon-setting"></i>
                <span slot="title">后台管理</span>
              </el-menu-item>
            </el-menu>
            <el-menu :default-active="activeIndex" class="el-menu-vertical-demo"  @open="handleOpen" @close="handleClose" style="margin-top:10px;border:none">
              <el-menu-item index="1" @click="toOrderList">
                <i class="el-icon-menu"></i>
                <span slot="title">我的订单</span>
              </el-menu-item>
               <el-menu-item index="7" @click="toUserList" v-if="user.isChannel == 1">
                <i class="el-icon-menu"></i>
                <span slot="title">用户订单</span>
              </el-menu-item>
              <el-menu-item index="8" @click="toCustomerList" v-if="user.isChannel == 3">
                <i class="el-icon-menu"></i>
                <span slot="title">客户订单</span>
              </el-menu-item>
              <el-menu-item index="2" @click="toMyAddress">
                <i class="el-icon-document"></i>
                <span slot="title">我的地址</span>
              </el-menu-item>
              <el-menu-item index="3" @click="toMyReport">
                <i class="el-icon-tickets"></i>
                <span slot="title">我的报告</span>
              </el-menu-item>
              <!--<el-menu-item index="4" @click="toMyRefund">-->
              <!--<i class="el-icon-menu"></i>-->
              <!--<span slot="title">我的退换</span>-->
              <!--</el-menu-item>-->
              <el-menu-item index="9" @click="toMyCoupons">
                <img class="navleft-icon" v-if="activeIndex === '9'" src="../assets/icon-mycoupons.png"/>
                <img class="navleft-icon" v-else src="../assets/icon-mycoupons-gray.png"/>
                <span slot="title">我的优惠券</span>
              </el-menu-item>
              <el-menu-item index="5" @click="toSetting">
                <i class="el-icon-setting"></i>
                <span slot="title">账户设置</span>
              </el-menu-item>
              <el-menu-item index="10" @click="toCouponsCenter">
                <img class="navleft-icon" v-if="activeIndex === '10'" src="../assets/icon-coupons-center.png"/>
                <img class="navleft-icon" v-else src="../assets/icon-coupons-center-gray.png"/>
                <span slot="title">领券中心</span>
              </el-menu-item>
              <el-menu-item index="6" @click="toSample" v-if="user.isChannel == 2">
                <i class="el-icon-setting"></i>
                <span slot="title">标本管理</span>
              </el-menu-item>
              <el-menu-item index="" @click="toManageSystem" v-if="user.isChannel != 0">
                <i class="el-icon-setting"></i>
                <span slot="title">后台管理</span>
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
  import '@/assets/css/index.css'

  export default {
    props: ["activeIndex"],
    name: "nav-left",

    data() {
      return {
        // user: {},
        // activeIndex:2\
        show:'',

      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    mounted() {

    },

    methods: {
      toshow(){
        this.show=!this.show;
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      toOrderList() {
        this.$router.replace("/mine/orderList")
      },
      toSetting() {
        this.$router.replace("/mine/setting")
      },
      toMyAddress() {
        this.$router.replace("/mine/myAddress")
      },
      toMyReport() {
        this.$router.replace("/mine/myReport")
      },
      toMyRefund() {
        this.$router.replace("/mine/myRefund")
      },
      toSample() {
        this.$router.replace("/mine/sampleManage")
      },
      toManageSystem() {
        // window.open('http://xcx.liferiverdx.com/#/login')
        // window.open('https://uat.liferiverai.cn/jyw-manage/#/login')
        window.open('https://manage.ujoyhealth.com')
      },
      toUserList(){
        this.$router.replace("/mine/userList")
      },
      toCustomerList() {
        this.$router.replace("/mine/customerList")
      },
      toMyCoupons() {
        this.$router.replace("/mine/myCoupons")
      },
      toCouponsCenter() {
        this.$router.replace("/couponsCenter")
      }
    }
  }
</script>

<style scoped>
  .userInfo {
    width: 100%;
    height: 150px;
    margin-top: 20px;

  }

  .userInfo .img_box {
    width: 50%;
    height: 100%;
    float: left;
  }

  .userInfo .img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }

  .userInfo .info_box {
    width: 50%;
    float: left;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .info_box *{
    vertical-align: middle;
  }

  .info_box .info {
    /*display: block;*/
    /*max-height: 80px;*/
    /*line-height: normal;*/
    /*text-align: left;*/
    /*overflow: hidden;*/
    /*margin-top: 44px;*/
    line-height: initial;
  }

  .info_box .label {
    display: block;
    width: 50px;
    height: 20px;
    line-height: 18px;
    font-size: 12px;
    color: #00C5B0;
    border: 1px solid #00C5B0;
    border-radius: 4px;
    text-align: center;
    margin: 0 auto;
  }
  .el-menu-item{
    text-align: left;
  }
  .el-menu-item.is-active {
    color: #00C5B0;
  }
  .imghide{
    display: none;
  }
  .navleft_menu{
    font-size: 14px;
    line-height: initial;
  }
  .navleft-icon{
    width: 18px;
    height: 18px;
    margin: 0 7px 0 3px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .userInfo {
      top: 0;
      position: absolute;
      left: 0;
    width: 100%;
    height: 34px;
    margin-top: 0;
      display: flex;justify-content: flex-start;
      border-bottom: none!important;
  }
.imghide{
    display: block;
  position: absolute;
  right: 10px;
  top: 10px;
  }
  .userInfo .img_box {
    width: 18px;
    height: 18px;
    position: relative;
    top: 7px;
    margin-right: 5px;
  }

  .userInfo .img {position: absolute;
    z-index: 11;left: 0;
    width: 18px;
    top: 0;
    height: 18px;
    border-radius: 50%;
  }

  .userInfo .info_box {
text-align: left;
  }
  .info_box .label{
    display: none;}
  .el-menu{
    position: absolute;
    right: 0;
    width: 145px;
    display: none;
    top: 22px;z-index: 6;
    box-shadow: -2px 3px 10px #ddd;

  }
.el-aside{
  background-color: #F0F0F0;
  height: 32px;
  overflow: initial;
}

.on{
  display: block;
}
.info_box .info{
  line-height: 32px;white-space: nowrap;
  width: 60px;
  overflow: hidden;text-overflow:ellipsis;
}

  }

</style>



// WEBPACK FOOTER //
// src/components/NavLeft.vue